// Centralised route constants for the treasury withdraw-requests module.
// Backend route renames are a one-file change.
//
// The treasury bank accounts picker endpoint moved to
// `treasury/treasuryAccounts/api/treasuryAccountsEndpointPaths.ts`
// when the shared query was promoted to its own sub-module.

const WITHDRAW_REQUESTS = '/api/admin/treasury/withdraw-requests'

export const WITHDRAW_REQUESTS_ENDPOINT_PATHS = {
  LIST: WITHDRAW_REQUESTS,
  STATUS_COUNTS: `${WITHDRAW_REQUESTS}/status-counts`,
  DETAIL: (id: string) => `${WITHDRAW_REQUESTS}/${id}`,
  APPROVE: (id: string) => `${WITHDRAW_REQUESTS}/${id}/approve`,
  MARK_SETTLED: (id: string) => `${WITHDRAW_REQUESTS}/${id}/mark-settled`,
  REJECT: (id: string) => `${WITHDRAW_REQUESTS}/${id}/reject`,
} as const
